import View from "../view";
import { RiskConfiguration } from "./riskConfiguration";
import { NavConfiguration } from "./navConfiguration";
import { NavItemConfiguration } from "./navItemConfiguration";
import { AssetOptions } from "./assetOptions";
import AnnuityType from "../annuityType";
import { WorkflowConfiguration } from "./workflowConfiguration";
import KeyValue from "../common/keyValue";
import { FooterConfiguration } from "./footerConfiguration";
import AccountRegistrationBehaviour from "../accountRegistrationBehaviour";
import AdviserListDisplayMode from "../adviserListDisplayMode";
import { AnonConfiguration } from "./anon/anonConfiguration";
import UserHomeCustomContentKey from "../userhomeCustomContentKey";
import LifeExpectancyBasis from "../lifeExpectancyBasis";
import GuaranteedIncomeDesignBehaviour from "../guaranteedIncome/guaranteedIncomeDesignBehaviour";
import { UIContent } from "@/guiide/ts/configuration/uiContent";

class Configuration {
  public constructor() {
    this.activeView = 1;
    this.monitor = false;
    this.gaKey = "";
    this.hotjarSiteId = "";
    this.dashboardShowCurrentContributionHelp = false;
    this.guaranteedIncomeEnabled = false;
    this.assetOptions = {
      pensionPots: false,
      finalSalary: false,
      savings: false,
      otherIncome: false,
      otherCash: false
    } as AssetOptions;
    this.nav = {
      home: {} as NavItemConfiguration,
      start: {} as NavItemConfiguration,
      design: {} as NavItemConfiguration,
      track: {} as NavItemConfiguration,
      login: {} as NavItemConfiguration
    } as NavConfiguration;
  }

  activeView: View;
  section: string;
  subSection: string;
  monitor: boolean;
  aiInstrumentationKey: string;
  gaKey: string;
  gtagTrackingId: string;
  adwordsId: string;
  hotjarSiteId: string;
  disconnected: boolean;
  companyFullName: string;
  companyAbbrevName: string;
  parentCompanyLink: string;
  olarkEnabled: boolean;
  requestCookieConsent: boolean;
  anonRedirect: string;
  site: string;
  title: string;
  anonConfiguration: AnonConfiguration;
  displayTitleInWorkflow: boolean;
  customHelpIcon: string;
  lifeExpectancyBasis: LifeExpectancyBasis;
  supportsFinalSalarySchemes: boolean;
  dashboardShowCurrentContributionHelp: boolean;
  standardUserCanCreateAccount: string;
  mainJourneyReferenceText: string;
  userHomeTrackIntroTitle: string;
  userHomeTrackIntroText: string;
  userHomeCustomContentKey: UserHomeCustomContentKey;
  guaranteedIncomeEnabled: boolean;
  designShowRiskHelp: boolean;
  designIncomeChartConfig: string;
  designGuaranteedIncomeBehaviour: GuaranteedIncomeDesignBehaviour;
  testDisplaysGuaranteedIncome: boolean;
  defaultExtraYearsForLiveLongerTest: number;
  guaranteedIncomeSuppliersHidden: boolean;
  annuityType: AnnuityType;
  canLinkLiveValuesFromHaves: boolean;
  canLinkLiveValuesFromDashboard: boolean;
  liveValuesLinkMoreFundsAdviceText: string;
  workflowShowsRetirementAge: boolean;
  showDayOfBirth: boolean;
  retirementDateReadOnly: boolean;
  showSex: boolean;
  youShowsCheckDataAlert: boolean;
  imageHintPath: string;
  solveIncludesEquityRelease: boolean;
  chartsIncomeUseGreyscaleColors: boolean;
  taxFreeCashOptions: Array<string>;
  havesSubHeadingText: string;
  havesPensionPotsListHeaderText: string;
  havesFinalSalaryListHeaderText: string;
  havesWarnWhenNoPensionPots: boolean;
  requirementsExpenseEditPriviledges: boolean;
  showTermsOfUse: boolean;
  termsOfUseResource: string;
  showTrustpilot: boolean;
  showPoweredBy: boolean;
  disclaimer: string;
  allowsSignup: boolean;
  signupBehaviour: AccountRegistrationBehaviour;
  signupPrompt: string;
  signupSecondaryPrompt: string;
  signupRequestsPhoneNumber: boolean;
  signupButtonText: string;
  signupPromptDisplayed: boolean;
  signupCompletedMessage: string;
  finishDisplaysNextButton: boolean;
  finishDisplaysProviders: boolean;
  finishDisplaysAdvisors: boolean;
  finishDisplaysPensionBeeSeparately: boolean;
  finishDisplaysOtherOptions: boolean;
  finishDisplaysCharges: boolean;
  finishDisplaysChargesExtraMessage: string;
  finishDisplaysChargesShowsPotCnsldnMsg: boolean;
  finishDisplaysAnnuity: boolean;
  finishDisplaysFinancialAdvice: boolean;
  finishDisplaysGenericCostOfFinancialAdvice: boolean;
  finishDisplaysOptionsNowYouHaveAPlan: boolean;
  finishDisplaysGuiideMarketing: boolean;
  finishCanViewPlanWithoutSignup: boolean;
  finishCanDownloadReport: boolean;
  providersLinkForII: string;
  providersShowsRetailers: boolean;
  adviserListTitle: string;
  adviserListDisplayMode: AdviserListDisplayMode;
  guiidePlusShowHeaderBanner: boolean;
  assetOptions: AssetOptions;
  risk: RiskConfiguration;
  solveIncPaymentsConfirmText: string;
  nav: NavConfiguration;
  workflow: WorkflowConfiguration;
  secureProductApplyActive: boolean;
  additionalInfo: Array<KeyValue>;
  footer: FooterConfiguration;
  uiContent: UIContent;

  public static getCssVariableValue(variableName: string): string {
    const styles = getComputedStyle(document.documentElement);
    return styles.getPropertyValue(variableName);
  }
}

const configuration = new Configuration();

export { Configuration, configuration };
